// @ts-nocheck
import "./styles.css";
    import { db, doc, setDoc, serverTimestamp, onSnapshot, ensureRemoteReady } from "./sync";
    const firebaseEnabled = true;
    const urlParams = new URLSearchParams(window.location.search);
    let processId = urlParams.get("id");
    const readOnlyMode = urlParams.get("view") === "1" || urlParams.get("readonly") === "1";
    let isLoadingRemote = false;
    let hasLoadedRemote = !processId;
    let editingLocked = Boolean(processId) || readOnlyMode;
    let saveOnlineTimer;
    let unsubscribeRealtime = null;
    let realtimeProcessId = null;
    const selectedCraftStateKey = "__selectedCraftKey";
    const defaultCraftKey = "6579:6899";
    let craftCatalog = { targets: [], items: [] };
    let catalogTargetsByKey = new Map();
    let catalogItemsById = new Map();
    let catalogLoaded = false;
    let catalogLoadFailed = false;

    function createEmptyRecipe() {
      return {
        key: "",
        itemId: null,
        itemName: "",
        item: "",
        successRate: 0,
        successRateLabel: "-",
        mpPerCraft: null,
        materials: []
      };
    }

    let recipe = createEmptyRecipe();

    let itemIcons = {
      "Recipe: Arcana Mace (60%)": "https://l2hub.info/s/icons-gf/etc_recipe_black_i00.png",
      "Arcana Mace Head": "https://l2hub.info/s/icons-gf/etc_squares_gray_i00.png",
      "Warsmith's Holder": "https://l2hub.info/s/icons-gf/etc_blacksmiths_frame_i00.png",
      "Mithril Alloy": "https://l2hub.info/s/icons-gf/etc_lump_white_i00.png",
      "Synthetic Cokes": "https://l2hub.info/s/icons-gf/etc_synthetic_cokes_i00.png",
      "Durable Metal Plate": "https://l2hub.info/s/icons-gf/etc_squares_wood_i00.png",
      "Enria": "https://l2hub.info/s/icons-gf/etc_gem_red_i00.png",
      "Crystal: S Grade": "https://l2hub.info/s/icons-gf/etc_crystal_gold_i00.png",
      "Gemstone S": "https://l2hub.info/s/icons-gf/etc_bead_silver_i00.png",
      "Asofe": "https://l2hub.info/s/icons-gf/etc_gem_blue_i00.png",
      "Thons": "https://l2hub.info/s/icons-gf/etc_gem_clear_i00.png",
      "Compound Braid": "https://l2hub.info/s/icons-gf/etc_compound_braid_i00.png",
      "Oriharukon": "https://l2hub.info/s/icons-gf/etc_oriharukon_i00.png",
      "Maestro Holder": "https://l2hub.info/s/icons-gf/etc_lump_yellow_i00.png",
      "Mold Glue": "https://l2hub.info/s/icons-gf/etc_reagent_red_i00.png",
      "Thread": "https://l2hub.info/s/icons-gf/etc_skein_white_i00.png",
      "Varnish of Purity": "https://l2hub.info/s/icons-gf/etc_potion_clear_i00.png",
      "Mold Lubricant": "https://l2hub.info/s/icons-gf/etc_reagent_gold_i00.png",
      "Mold Hardener": "https://l2hub.info/s/icons-gf/etc_reagent_blue_i00.png",
      "Steel": "https://l2hub.info/s/icons-gf/etc_lump_black_i00.png",
      "Mithril Ore": "https://l2hub.info/s/icons-gf/etc_mithril_ore_i00.png",
      "Cokes": "https://l2hub.info/s/icons-gf/etc_oil_pot_black_i00.png",
      "Oriharukon Ore": "https://l2hub.info/s/icons-gf/etc_oriharukon_ore_i00.png",
      "Metallic Thread": "https://l2hub.info/s/icons-gf/etc_skein_gray_i00.png",
      "Coarse Bone Powder": "https://l2hub.info/s/icons-gf/etc_powder_white_i00.png",
      "Varnish": "https://l2hub.info/s/icons-gf/etc_pouch_yellow_i00.png",
      "Stone of Purity": "https://l2hub.info/s/icons-gf/etc_crystal_ball_white_i00.png",
      "Iron Ore": "https://l2hub.info/s/icons-gf/etc_lump_gray_i00.png",
      "Coal": "https://l2hub.info/s/icons-gf/etc_coal_i00.png",
      "Charcoal": "https://l2hub.info/s/icons-gf/etc_charcoal_i00.png",
      "Animal Bone": "https://l2hub.info/s/icons-gf/etc_piece_bone_white_i00.png"
    };

    let craftRecipes = {
      "Warsmith's Holder": {
        resultQty: 1,
        materials: [
          { name: "Maestro Holder", qty: 2 },
          { name: "Mold Glue", qty: 10 },
          { name: "Thread", qty: 20 }
        ]
      },
      "Maestro Holder": {
        resultQty: 1,
        materials: [
          { name: "Varnish of Purity", qty: 10 },
          { name: "Mold Lubricant", qty: 10 },
          { name: "Mold Hardener", qty: 10 }
        ]
      },
      "Mithril Alloy": {
        resultQty: 1,
        materials: [
          { name: "Varnish of Purity", qty: 1 },
          { name: "Steel", qty: 2 },
          { name: "Mithril Ore", qty: 1 }
        ]
      },
      "Synthetic Cokes": {
        resultQty: 1,
        materials: [
          { name: "Cokes", qty: 3 },
          { name: "Oriharukon Ore", qty: 1 }
        ]
      },
      "Durable Metal Plate": {
        resultQty: 1,
        materials: [
          { name: "Metallic Thread", qty: 5 },
          { name: "Mithril Ore", qty: 5 }
        ]
      },
      "Varnish of Purity": {
        resultQty: 1,
        materials: [
          { name: "Coarse Bone Powder", qty: 3 },
          { name: "Varnish", qty: 3 },
          { name: "Stone of Purity", qty: 1 }
        ]
      },
      "Steel": {
        resultQty: 1,
        materials: [
          { name: "Varnish", qty: 5 },
          { name: "Iron Ore", qty: 5 }
        ]
      },
      "Cokes": {
        resultQty: 1,
        materials: [
          { name: "Coal", qty: 3 },
          { name: "Charcoal", qty: 3 }
        ]
      },
      "Coarse Bone Powder": {
        resultQty: 1,
        materials: [
          { name: "Animal Bone", qty: 10 }
        ]
      },
      "Metallic Thread": {
        resultQty: 1,
        materials: [
          { name: "Thread", qty: 10 },
          { name: "Iron Ore", qty: 5 }
        ]
      }
    };

    const stateKey = "arcana-mace-interlude-craft-calculator";
    const formatter = new Intl.NumberFormat("pt-BR");
    const decimalFormatter = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
    const languageStateKey = "l2craft-language";
    const languageOptions = {
      pt: { htmlLang: "pt-BR", label: "Português" },
      en: { htmlLang: "en", label: "English" },
      ru: { htmlLang: "ru", label: "Русский" }
    };
    const translations = {
      pt: {
        appTitle: "Calculadora de Craft",
        pageTitle: "Calculadora de Craft - {item}",
        subtitle: "Receitas craftaveis de Lineage 2 Interlude, com dados da pagina de craft do",
        languageSwitcher: "Idioma",
        craftSettings: "Configuracoes de craft",
        craftableItem: "Item craftavel",
        searchPlaceholder: "Pesquisar item craftavel...",
        catalogLoading: "Carregando lista de crafts...",
        craftsLoaded: "{count} receitas craftaveis carregadas.",
        catalogLoadFailed: "Nao foi possivel carregar a lista completa; usando Arcana Mace local.",
        catalogUnavailable: "Nao foi possivel carregar a lista completa.",
        catalogStillLoading: "A lista de crafts ainda esta carregando.",
        crafts: "Crafts",
        shortcuts: "Atalhos",
        quickQuantity: "Quantidade rapida",
        addCraft: "Adicionar/atualizar",
        activeCrafts: "Crafts ativos",
        noActiveCrafts: "Nenhum craft ativo.",
        changeCraftQty: "Quantidade de crafts de {item}",
        removeCraft: "Remover {item}",
        craftAdded: "{item} adicionado ao calculo.",
        craftUpdated: "{item} atualizado no calculo.",
        craftRemoved: "{item} removido do calculo.",
        multiCraftTitle: "{count} itens",
        overallCraftProgress: "Progresso geral do craft",
        overallWithSubcrafts: "Progresso geral",
        materialsUnit: "materiais",
        summary: "Resumo",
        overallProcess: "Processo geral",
        chance: "Chance",
        expectedSuccess: "Sucesso esperado",
        materialsWithSubcrafts: "Materiais com subcrafts",
        actionsAndMissing: "Acoes e faltas",
        copyMissing: "Copiar faltas",
        saveOnline: "Salvar online",
        copyEditableLink: "Copiar link editavel",
        copyViewLink: "Copiar link sem edicao",
        copyThisViewLink: "Copiar link desta visualizacao",
        resetInventory: "Zerar inventario",
        markAllReady: "Marcar tudo pronto",
        missingMaterials: "Materiais em falta",
        missingList: "Lista de faltas",
        pendingCrafts: "Crafts pendentes",
        noPendingCrafts: "Nenhum craft pendente",
        material: "Material",
        have: "Tenho",
        progressPercent: "Avanco %",
        expandSubitems: "Expandir",
        collapseSubitems: "Recolher",
        expandSubitemsOf: "{action} subitens de {item}. Craftar {qty}.",
        subitemsTitle: "{action} subitens",
        haveItem: "Tenho {item}",
        progressOf: "Progresso de {item}",
        selectCraftFirst: "Selecione um item craftavel para comecar.",
        noBuyableMissing: "Nenhuma falta compravel",
        allReady: "Tudo pronto",
        fang: "Fang",
        missingTextReady: "{item}: todos os materiais estao prontos.",
        missingTextHeader: "{item} - faltas com subcrafts para {qty} crafts:",
        pendingCraftTextHeader: "Crafts pendentes:",
        pendingCraftTextLine: "{item}: craftar {crafts}",
        missingFangAlternativeHeader: "Alternativa com Fang of Stakato:",
        missingFangAlternativeLine: "{item}: {missing} | Fang of Stakato: {fang}",
        missingFangAlternativeTotal: "Total Fang of Stakato: {fang}",
        itemNotFound: "Item craftavel nao encontrado.",
        inventoryReset: "Inventario zerado.",
        materialsMarkedReady: "Materiais marcados como prontos.",
        missingCopied: "Lista copiada.",
        copyMissingManual: "Copie a lista manualmente na lateral.",
        processLinkPrompt: "Copie o link do processo:",
        copiedViewLink: "Link sem edicao copiado.",
        copiedEditLink: "Link editavel copiado.",
        copiedManual: "Copie o link manualmente.",
        readOnlyLink: "Este link e somente para visualizacao.",
        firebaseConfigMissing: "Configure o firebaseConfig no codigo antes de salvar online.",
        firebaseNotConfigured: "Firebase nao configurado",
        waitOnlineProcess: "Aguarde o processo online carregar.",
        processSaved: "Processo salvo online.",
        onlineSaveError: "Erro ao salvar online",
        savingOnline: "Salvando online",
        connectingProcess: "Conectando ao processo",
        openingView: "Abrindo visualizacao",
        viewWithoutProcess: "Visualizacao sem processo salvo",
        linkWithoutProcess: "Link sem processo salvo",
        processNotSavedYet: "Processo online ainda nao existe. Clique em Salvar online para criar.",
        realtimeView: "Visualizacao em tempo real",
        realtimeOnline: "Online em tempo real",
        syncError: "Erro na sincronizacao",
        realtimeError: "Erro no tempo real. Confira Firebase, Firestore e regras.",
        localOnly: "Somente local",
        enableFirestore: "Ative Cloud Firestore no Firebase.",
        firestorePermission: "Firestore sem permissao para salvar. Atualize as regras em craftProcesses.",
        firestoreError: "Erro no Firestore. Confira o Firebase.",
        footerText: "Arcana Mace Interlude: item ID 6579, Crystal: S Grade 2.440. A expectativa de sucesso e apenas media estatistica; cada tentativa continua independente. O calculo de Fang of Stakato e referente ao servidor Eternal do L2 Reborn."
      },
      en: {
        appTitle: "Craft Calculator",
        pageTitle: "Craft Calculator - {item}",
        subtitle: "Craftable Lineage 2 Interlude recipes, using craft-page data from",
        languageSwitcher: "Language",
        craftSettings: "Craft settings",
        craftableItem: "Craftable item",
        searchPlaceholder: "Search craftable item...",
        catalogLoading: "Loading craft list...",
        craftsLoaded: "{count} craftable recipes loaded.",
        catalogLoadFailed: "Could not load the full list; using local Arcana Mace data.",
        catalogUnavailable: "Could not load the full list.",
        catalogStillLoading: "The craft list is still loading.",
        crafts: "Crafts",
        shortcuts: "Shortcuts",
        quickQuantity: "Quick quantity",
        addCraft: "Add/update",
        activeCrafts: "Active crafts",
        noActiveCrafts: "No active crafts.",
        changeCraftQty: "Craft quantity for {item}",
        removeCraft: "Remove {item}",
        craftAdded: "{item} added to the calculator.",
        craftUpdated: "{item} updated in the calculator.",
        craftRemoved: "{item} removed from the calculator.",
        multiCraftTitle: "{count} items",
        overallCraftProgress: "Overall craft progress",
        overallWithSubcrafts: "Overall progress with subcrafts",
        materialsUnit: "materials",
        summary: "Summary",
        overallProcess: "Overall process",
        chance: "Chance",
        expectedSuccess: "Expected success",
        materialsWithSubcrafts: "Materials with subcrafts",
        actionsAndMissing: "Actions and missing items",
        copyMissing: "Copy missing",
        saveOnline: "Save online",
        copyEditableLink: "Copy editable link",
        copyViewLink: "Copy view-only link",
        copyThisViewLink: "Copy this view link",
        resetInventory: "Reset inventory",
        markAllReady: "Mark all ready",
        missingMaterials: "Missing materials",
        missingList: "Missing list",
        pendingCrafts: "Pending crafts",
        noPendingCrafts: "No pending crafts",
        material: "Material",
        have: "Have",
        progressPercent: "Progress %",
        expandSubitems: "Expand",
        collapseSubitems: "Collapse",
        expandSubitemsOf: "{action} subitems for {item}. Craft {qty}.",
        subitemsTitle: "{action} subitems",
        haveItem: "Have {item}",
        progressOf: "Progress for {item}",
        selectCraftFirst: "Select a craftable item to start.",
        noBuyableMissing: "No buyable missing items",
        allReady: "All ready",
        fang: "Fang",
        missingTextReady: "{item}: all materials are ready.",
        missingTextHeader: "{item} - missing with subcrafts for {qty} crafts:",
        pendingCraftTextHeader: "Pending crafts:",
        pendingCraftTextLine: "{item}: craft {crafts}",
        missingFangAlternativeHeader: "Fang of Stakato alternative:",
        missingFangAlternativeLine: "{item}: {missing} | Fang of Stakato: {fang}",
        missingFangAlternativeTotal: "Total Fang of Stakato: {fang}",
        itemNotFound: "Craftable item not found.",
        inventoryReset: "Inventory reset.",
        materialsMarkedReady: "Materials marked as ready.",
        missingCopied: "List copied.",
        copyMissingManual: "Copy the list manually from the side panel.",
        processLinkPrompt: "Copy the process link:",
        copiedViewLink: "View-only link copied.",
        copiedEditLink: "Editable link copied.",
        copiedManual: "Copy the link manually.",
        readOnlyLink: "This link is view-only.",
        firebaseConfigMissing: "Configure firebaseConfig in the code before saving online.",
        firebaseNotConfigured: "Firebase not configured",
        waitOnlineProcess: "Wait for the online process to load.",
        processSaved: "Process saved online.",
        onlineSaveError: "Error saving online",
        savingOnline: "Saving online",
        connectingProcess: "Connecting to process",
        openingView: "Opening view",
        viewWithoutProcess: "View without saved process",
        linkWithoutProcess: "Link without saved process",
        processNotSavedYet: "The online process does not exist yet. Click Save online to create it.",
        realtimeView: "Realtime view",
        realtimeOnline: "Online in realtime",
        syncError: "Sync error",
        realtimeError: "Realtime error. Check Firebase, Firestore, and rules.",
        localOnly: "Local only",
        enableFirestore: "Enable Cloud Firestore in Firebase.",
        firestorePermission: "Firestore has no permission to save. Update the rules for craftProcesses.",
        firestoreError: "Firestore error. Check Firebase.",
        footerText: "Arcana Mace Interlude: item ID 6579, Crystal: S Grade 2,440. Expected success is only a statistical average; every attempt remains independent. The Fang of Stakato calculation refers to the Eternal server on L2 Reborn."
      },
      ru: {
        appTitle: "Калькулятор крафта",
        pageTitle: "Калькулятор крафта - {item}",
        subtitle: "Крафтовые рецепты Lineage 2 Interlude, данные со страницы крафта",
        languageSwitcher: "Язык",
        craftSettings: "Настройки крафта",
        craftableItem: "Предмет для крафта",
        searchPlaceholder: "Найти предмет для крафта...",
        catalogLoading: "Загрузка списка крафтов...",
        craftsLoaded: "Загружено рецептов: {count}.",
        catalogLoadFailed: "Не удалось загрузить полный список; используются локальные данные Arcana Mace.",
        catalogUnavailable: "Не удалось загрузить полный список.",
        catalogStillLoading: "Список крафтов еще загружается.",
        crafts: "Крафты",
        shortcuts: "Быстрый выбор",
        quickQuantity: "Быстрое количество",
        addCraft: "Add/update",
        activeCrafts: "Active crafts",
        noActiveCrafts: "No active crafts.",
        changeCraftQty: "Craft quantity for {item}",
        removeCraft: "Remove {item}",
        craftAdded: "{item} added to the calculator.",
        craftUpdated: "{item} updated in the calculator.",
        craftRemoved: "{item} removed from the calculator.",
        multiCraftTitle: "{count} items",
        overallCraftProgress: "Общий прогресс крафта",
        overallWithSubcrafts: "Общий прогресс с подкрафтами",
        materialsUnit: "материалов",
        summary: "Сводка",
        overallProcess: "Общий процесс",
        chance: "Шанс",
        expectedSuccess: "Ожидаемый успех",
        materialsWithSubcrafts: "Материалы с подкрафтами",
        actionsAndMissing: "Действия и нехватка",
        copyMissing: "Скопировать нехватку",
        saveOnline: "Сохранить онлайн",
        copyEditableLink: "Скопировать ссылку для редактирования",
        copyViewLink: "Скопировать ссылку просмотра",
        copyThisViewLink: "Скопировать ссылку этого просмотра",
        resetInventory: "Обнулить инвентарь",
        markAllReady: "Отметить все готовым",
        missingMaterials: "Не хватает материалов",
        missingList: "Список нехватки",
        pendingCrafts: "Pending crafts",
        noPendingCrafts: "No pending crafts",
        material: "Материал",
        have: "Есть",
        progressPercent: "Прогресс %",
        expandSubitems: "Развернуть",
        collapseSubitems: "Свернуть",
        expandSubitemsOf: "{action} подматериалы для {item}. Крафт: {qty}.",
        subitemsTitle: "{action} подматериалы",
        haveItem: "Есть {item}",
        progressOf: "Прогресс для {item}",
        selectCraftFirst: "Выберите предмет для крафта, чтобы начать.",
        noBuyableMissing: "Нет покупаемой нехватки",
        allReady: "Все готово",
        fang: "Fang",
        missingTextReady: "{item}: все материалы готовы.",
        missingTextHeader: "{item} - нехватка с подкрафтами для {qty} крафтов:",
        pendingCraftTextHeader: "Pending crafts:",
        pendingCraftTextLine: "{item}: craft {crafts}",
        missingFangAlternativeHeader: "Альтернатива через Fang of Stakato:",
        missingFangAlternativeLine: "{item}: {missing} | Fang of Stakato: {fang}",
        missingFangAlternativeTotal: "Всего Fang of Stakato: {fang}",
        itemNotFound: "Предмет для крафта не найден.",
        inventoryReset: "Инвентарь обнулен.",
        materialsMarkedReady: "Материалы отмечены как готовые.",
        missingCopied: "Список скопирован.",
        copyMissingManual: "Скопируйте список вручную в боковой панели.",
        processLinkPrompt: "Скопируйте ссылку процесса:",
        copiedViewLink: "Ссылка просмотра скопирована.",
        copiedEditLink: "Ссылка для редактирования скопирована.",
        copiedManual: "Скопируйте ссылку вручную.",
        readOnlyLink: "Эта ссылка только для просмотра.",
        firebaseConfigMissing: "Настройте firebaseConfig в коде перед онлайн-сохранением.",
        firebaseNotConfigured: "Firebase не настроен",
        waitOnlineProcess: "Дождитесь загрузки онлайн-процесса.",
        processSaved: "Процесс сохранен онлайн.",
        onlineSaveError: "Ошибка онлайн-сохранения",
        savingOnline: "Сохранение онлайн",
        connectingProcess: "Подключение к процессу",
        openingView: "Открытие просмотра",
        viewWithoutProcess: "Просмотр без сохраненного процесса",
        linkWithoutProcess: "Ссылка без сохраненного процесса",
        processNotSavedYet: "Онлайн-процесс еще не существует. Нажмите Сохранить онлайн, чтобы создать его.",
        realtimeView: "Просмотр в реальном времени",
        realtimeOnline: "Онлайн в реальном времени",
        syncError: "Ошибка синхронизации",
        realtimeError: "Ошибка реального времени. Проверьте Firebase, Firestore и правила.",
        localOnly: "Только локально",
        enableFirestore: "Включите Cloud Firestore в Firebase.",
        firestorePermission: "У Firestore нет разрешения. Проверьте правила.",
        firestoreError: "Ошибка Firestore. Проверьте Firebase.",
        footerText: "Arcana Mace Interlude: item ID 6579, Crystal: S Grade 2 440. Ожидаемый успех - только статистическое среднее; каждая попытка остается независимой. Расчет Fang of Stakato относится к серверу Eternal на L2 Reborn."
      }
    };
    let currentLanguage = normalizeLanguage(localStorage.getItem(languageStateKey) || "pt");
    const fangExchangeRates = [
      { name: "Enria", quantity: 1, fangCost: 12 },
      { name: "Asofe", quantity: 1, fangCost: 6 },
      { name: "Thons", quantity: 1, fangCost: 6 },
      { name: "Varnish of Purity", quantity: 10, fangCost: 81 },
      { name: "Synthetic Cokes", quantity: 5, fangCost: 33 },
      { name: "Compound Braid", quantity: 10, fangCost: 30 },
      { name: "Mithril Alloy", quantity: 10, fangCost: 131 },
      { name: "Durable Metal Plate", quantity: 10, fangCost: 150 },
      { name: "Oriharukon", quantity: 5, fangCost: 123 }
    ];
    const fangExchangeByName = new Map(fangExchangeRates.map((rate) => [rate.name, rate]));
    const elements = {
      title: document.querySelector("#title"),
      subtitleText: document.querySelector("#subtitleText"),
      itemIcon: document.querySelector("#itemIcon"),
      sourceLink: document.querySelector("#sourceLink"),
      languageButtons: document.querySelectorAll("[data-language]"),
      craftSearch: document.querySelector("#craftSearch"),
      craftOptions: document.querySelector("#craftOptions"),
      catalogMeta: document.querySelector("#catalogMeta"),
      craftQty: document.querySelector("#craftQty"),
      addCraft: document.querySelector("#addCraft"),
      activeCrafts: document.querySelector("#activeCrafts"),
      activeCraftCount: document.querySelector("#activeCraftCount"),
      materials: document.querySelector("#materials"),
      overallProgressBar: document.querySelector("#overallProgressBar"),
      overallProgressText: document.querySelector("#overallProgressText"),
      overallProgressCard: document.querySelector("#overallProgressCard"),
      overallProgressUnits: document.querySelector("#overallProgressUnits"),
      fireworksCanvas: document.querySelector("#fireworksCanvas"),
      successRate: document.querySelector("#successRate"),
      expectedSuccess: document.querySelector("#expectedSuccess"),
      missingKinds: document.querySelector("#missingKinds"),
      missingTotal: document.querySelector("#missingTotal"),
      missingList: document.querySelector("#missingList"),
      pendingCraftTotal: document.querySelector("#pendingCraftTotal"),
      pendingCraftList: document.querySelector("#pendingCraftList"),
      fangTotal: document.querySelector("#fangTotal"),
      fangList: document.querySelector("#fangList"),
      syncStatusBox: document.querySelector("#syncStatusBox"),
      syncStatusText: document.querySelector("#syncStatusText"),
      toast: document.querySelector("#toast"),
      saveOnline: document.querySelector("#saveOnline"),
      copyProcessLink: document.querySelector("#copyProcessLink"),
      copyViewProcessLink: document.querySelector("#copyViewProcessLink"),
      resetInventory: document.querySelector("#resetInventory"),
      fillRequired: document.querySelector("#fillRequired")
    };

    function normalizeLanguage(language) {
      const normalized = String(language || "").slice(0, 2).toLowerCase();
      return languageOptions[normalized] ? normalized : "pt";
    }

    function t(key, params = {}) {
      const template = translations[currentLanguage]?.[key] ?? translations.pt[key] ?? key;
      return template.replace(/\{(\w+)\}/g, (_, name) => (
        params[name] == null ? "" : String(params[name])
      ));
    }

    function isTranslationKey(key) {
      return Boolean(translations[currentLanguage]?.[key] ?? translations.pt[key]);
    }

    function applyTranslations() {
      document.documentElement.lang = languageOptions[currentLanguage].htmlLang;

      document.querySelectorAll("[data-i18n]").forEach((element) => {
        element.textContent = t(element.dataset.i18n);
      });

      document.querySelectorAll("[data-i18n-placeholder]").forEach((element) => {
        element.placeholder = t(element.dataset.i18nPlaceholder);
      });

      document.querySelectorAll("[data-i18n-aria-label]").forEach((element) => {
        element.setAttribute("aria-label", t(element.dataset.i18nAriaLabel));
      });

      elements.subtitleText.textContent = t("subtitle");
      elements.languageButtons.forEach((button) => {
        const active = button.dataset.language === currentLanguage;
        button.classList.toggle("active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });

      if (readOnlyMode) {
        elements.copyViewProcessLink.textContent = t("copyThisViewLink");
      }

      if (catalogLoaded) {
        renderCraftSearchOptions();
      } else if (catalogLoadFailed) {
        elements.catalogMeta.textContent = t("catalogLoadFailed");
      }

      syncSelectedCraftUi();
      renderSyncStatus();
    }

    function setLanguage(language) {
      const nextLanguage = normalizeLanguage(language);
      if (nextLanguage === currentLanguage) return;

      currentLanguage = nextLanguage;
      localStorage.setItem(languageStateKey, currentLanguage);
      applyTranslations();
      render({ persist: false, online: false });
    }

    const defaultState = {
      selectedTargetKey: "",
      quantity: 20,
      crafts: [],
      inventory: {},
      expanded: {}
    };

    let state = loadLocalState();
    let currentSyncStatus = {
      kind: "local",
      message: "localOnly",
      params: {},
      isKey: true
    };
    let previousOverallProgressPercent = null;
    let fireworksAnimationFrame = 0;
    let fireworksStopTimer = 0;
    let fireworksParticles = [];

    function normalizeState(value) {
      const craftParam = urlParams.get("craft");
      const selectedTargetKey = craftParam ||
        (processId ? (value?.selectedTargetKey || value?.expanded?.[selectedCraftStateKey]) : "") ||
        "";
      const quantity = Math.max(toSafeNumber(value?.quantity, defaultState.quantity), 1);
      const shouldUseUrlCraft = Boolean(craftParam && !processId && !Array.isArray(value?.crafts));
      const hasCrafts = Array.isArray(value?.crafts) && !shouldUseUrlCraft;
      const crafts = hasCrafts
        ? normalizeCraftEntries(value.crafts)
        : normalizeCraftEntries(selectedTargetKey ? [{ targetKey: selectedTargetKey, quantity }] : []);
      const nextSelectedTargetKey = String(selectedTargetKey || crafts[0]?.targetKey || "");

      return {
        ...defaultState,
        ...(value || {}),
        selectedTargetKey: nextSelectedTargetKey,
        quantity,
        crafts,
        inventory: value?.inventory || {},
        expanded: value?.expanded || {}
      };
    }

    function normalizeCraftEntries(crafts = []) {
      const entriesByKey = new Map();

      crafts.forEach((craft) => {
        const targetKey = String(craft?.targetKey || craft?.key || craft?.selectedTargetKey || "");
        const quantity = Math.max(toSafeNumber(craft?.quantity, defaultState.quantity), 1);
        if (!targetKey) return;

        const current = entriesByKey.get(targetKey);
        if (current) {
          current.quantity += quantity;
        } else {
          entriesByKey.set(targetKey, { targetKey, quantity });
        }
      });

      return [...entriesByKey.values()];
    }

    function getPrimaryCraftKey({ activeOnly = false } = {}) {
      const activeCraftKey = state.crafts[0]?.targetKey || "";
      if (activeCraftKey || activeOnly) return activeCraftKey;
      return state.selectedTargetKey || "";
    }

    function syncCraftUrl() {
      const url = new URL(window.location.href);
      const craftKey = getPrimaryCraftKey({ activeOnly: true });
      if (craftKey) {
        url.searchParams.set("craft", craftKey);
      } else {
        url.searchParams.delete("craft");
      }
      window.history.replaceState({}, "", url);
    }

    function getShareUrl(id = processId, { readOnly = false } = {}) {
      const url = new URL(window.location.href);
      url.searchParams.set("id", id);
      const craftKey = getPrimaryCraftKey({ activeOnly: true });
      if (craftKey) {
        url.searchParams.set("craft", craftKey);
      } else {
        url.searchParams.delete("craft");
      }
      url.searchParams.delete("run");
      url.searchParams.delete("test");
      url.searchParams.delete("verify");
      url.searchParams.delete("diagnostic");

      if (readOnly) {
        url.searchParams.set("view", "1");
      } else {
        url.searchParams.delete("view");
        url.searchParams.delete("readonly");
      }

      return url.toString();
    }

    function getFirestoreErrorMessage(payload) {
      const error = payload?.error;
      const reason = error?.details?.find((detail) => detail.reason)?.reason;

      if (reason === "SERVICE_DISABLED") {
        return t("enableFirestore");
      }

      if (error?.status === "PERMISSION_DENIED") {
        return t("firestorePermission");
      }

      return t("firestoreError");
    }

    function getFirebaseClientErrorMessage(error) {
      const message = String(error?.message || "");
      if (error?.code === "permission-denied" || message.toLowerCase().includes("missing or insufficient permissions")) {
        return t("firestorePermission");
      }

      return message || t("onlineSaveError");
    }

    async function ensureFirestoreReady(id) {
      await ensureRemoteReady(id);
    }

    async function copyProcessLinkToClipboard(id = processId, { readOnly = false } = {}) {
      const link = getShareUrl(id, { readOnly });
      const copiedMessage = readOnly ? t("copiedViewLink") : t("copiedEditLink");

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(link);
          showToast(copiedMessage);
        } else {
          throw new Error("clipboard unavailable");
        }
      } catch {
        window.prompt(t("processLinkPrompt"), link);
        showToast(t("copiedManual"));
      }
    }

    function getIconUrl(icon) {
      if (!icon) return "https://l2hub.info/s/icons-gf/etc_recipe_black_i00.png";
      if (icon.startsWith("http")) return icon;
      return `https://l2hub.info/s/icons-gf/${icon}.png`;
    }

    function getTargetLabel(target) {
      if (!target) return recipe.item;
      const rate = target.rate == null ? "" : ` (${target.rate}%)`;
      return `${target.item.name}${rate}`;
    }

    function getItemData(itemId) {
      return catalogItemsById.get(Number(itemId)) || {
        id: Number(itemId),
        itemName: `item_${itemId}`,
        name: `Item #${itemId}`,
        icon: "etc_recipe_black_i00",
        recipes: []
      };
    }

    function getTargetKey(target) {
      if (!target) return "";
      return target?.key || `${target?.item?.id}:${target?.recipeId}`;
    }

    function resolveTargetKey(targetKey) {
      const key = String(targetKey || "");
      if (!key) return "";
      if (catalogTargetsByKey.has(key)) return key;

      const byItemId = craftCatalog.targets.find((target) => String(target.item.id) === key);
      return byItemId ? getTargetKey(byItemId) : "";
    }

    function repairCraftEntriesFromCatalog() {
      if (!catalogLoaded) return;

      state.selectedTargetKey = resolveTargetKey(state.selectedTargetKey);
      state.crafts = normalizeCraftEntries(state.crafts.map((craft) => ({
        targetKey: resolveTargetKey(craft.targetKey),
        quantity: craft.quantity
      })).filter((craft) => craft.targetKey));

      if (!state.selectedTargetKey && state.crafts.length) {
        state.selectedTargetKey = state.crafts[0].targetKey;
      }

      const selectedCraft = state.crafts.find((craft) => craft.targetKey === state.selectedTargetKey);
      if (selectedCraft) {
        state.quantity = selectedCraft.quantity;
      }
    }

    function getCurrentTarget() {
      return catalogTargetsByKey.get(state.selectedTargetKey) || null;
    }

    function createCraftEntry(target, quantity) {
      const targetKey = getTargetKey(target);

      return {
        targetKey,
        target,
        quantity: Math.max(toSafeNumber(quantity, 1), 1),
        item: target.item.name,
        itemName: target.item.itemName,
        successRate: (target.rate == null ? 100 : target.rate) / 100,
        successRateLabel: target.rate == null ? "100%" : `${target.rate}%`,
        materials: target.recipe.mats.map((material) => {
          const item = getItemData(material.itemId);
          return {
            name: item.name,
            perCraft: material.count,
            icon: getIconUrl(item.icon)
          };
        })
      };
    }

    function getActiveCrafts() {
      return state.crafts
        .map((craft) => {
          const target = catalogTargetsByKey.get(craft.targetKey);
          if (!target) return null;
          return createCraftEntry(target, craft.quantity);
        })
        .filter(Boolean);
    }

    function getCraftSetTitle(activeCrafts = getActiveCrafts()) {
      if (!activeCrafts.length) return "";
      if (activeCrafts.length === 1) return activeCrafts[0].item;
      return t("multiCraftTitle", { count: formatNumber(activeCrafts.length) });
    }

    function getTotalCraftQuantity(activeCrafts = getActiveCrafts()) {
      return activeCrafts.reduce((sum, craft) => sum + craft.quantity, 0);
    }

    function getCraftNameTokens(activeCrafts = getActiveCrafts()) {
      const ignoredTokens = new Set(["and", "for", "the", "of"]);

      return activeCrafts.flatMap((craft) => (
        String(craft.item || "")
          .toLowerCase()
          .split(/[^a-z0-9]+/)
          .filter((token) => token.length >= 3 && !ignoredTokens.has(token))
      ));
    }

    function matchesCraftNameToken(name, activeCrafts = getActiveCrafts()) {
      const normalizedName = String(name || "").toLowerCase();
      return getCraftNameTokens(activeCrafts).some((token) => normalizedName.includes(token));
    }

    function getMaterialSortGroup(name, activeCrafts = getActiveCrafts()) {
      const normalizedName = String(name || "").toLowerCase();
      if (normalizedName.startsWith("recipe:")) return 0;
      if (normalizedName.startsWith("crystal:") || normalizedName.startsWith("gemstone")) return 3;
      if (matchesCraftNameToken(name, activeCrafts)) return 1;
      return 2;
    }

    function sortMaterialsByPriority(materials, activeCrafts = getActiveCrafts()) {
      return [...materials]
        .map((material, index) => ({ material, index }))
        .sort((left, right) => {
          const groupDifference = getMaterialSortGroup(left.material.name, activeCrafts) - getMaterialSortGroup(right.material.name, activeCrafts);
          return groupDifference || left.index - right.index;
        })
        .map((entry) => entry.material);
    }

    function getTopMaterialRequests(activeCrafts = getActiveCrafts()) {
      const materialsByName = new Map();

      activeCrafts.forEach((craft) => {
        craft.materials.forEach((material) => {
          const quantity = material.perCraft * craft.quantity;
          if (quantity <= 0) return;

          const current = materialsByName.get(material.name);
          if (current) {
            current.quantity += quantity;
          } else {
            materialsByName.set(material.name, {
              name: material.name,
              quantity,
              icon: material.icon
            });
          }
        });
      });

      return sortMaterialsByPriority([...materialsByName.values()], activeCrafts);
    }

    function getSuccessRateSummary(activeCrafts = getActiveCrafts()) {
      if (!activeCrafts.length) return "-";
      const rates = [...new Set(activeCrafts.map((craft) => craft.successRateLabel))];
      if (rates.length <= 2) return rates.join(" / ");

      const numericRates = activeCrafts.map((craft) => Math.round(craft.successRate * 100));
      return `${Math.min(...numericRates)}%-${Math.max(...numericRates)}%`;
    }

    function getExpectedSuccessTotal(activeCrafts = getActiveCrafts()) {
      return activeCrafts.reduce((sum, craft) => sum + (craft.quantity * craft.successRate), 0);
    }

    function applyCatalogTarget() {
      const nextIcons = {};
      const nextCraftRecipes = {};

      craftCatalog.items.forEach((item) => {
        nextIcons[item.name] = getIconUrl(item.icon);

        const craft = item.recipes?.[0];
        if (!craft?.mats?.length) return;

        nextCraftRecipes[item.name] = {
          resultQty: Math.max(toSafeNumber(craft.prod?.[0]?.count, 1), 1),
          materials: craft.mats.map((material) => {
            const materialItem = getItemData(material.itemId);
            return {
              name: materialItem.name,
              qty: material.count
            };
          })
        };
      });

      itemIcons = nextIcons;
      craftRecipes = nextCraftRecipes;
      repairCraftEntriesFromCatalog();

      const activeCrafts = getActiveCrafts();
      if (!activeCrafts.length) {
        recipe = createEmptyRecipe();
        return;
      }

      recipe = {
        key: activeCrafts.map((craft) => craft.targetKey).join(","),
        itemId: activeCrafts.length === 1 ? activeCrafts[0].target.item.id : null,
        itemName: activeCrafts.length === 1 ? activeCrafts[0].itemName : "",
        item: getCraftSetTitle(activeCrafts),
        successRate: activeCrafts.length === 1 ? activeCrafts[0].successRate : 0,
        successRateLabel: getSuccessRateSummary(activeCrafts),
        mpPerCraft: activeCrafts.length === 1 && activeCrafts[0].targetKey === defaultCraftKey ? 225 : null,
        materials: getTopMaterialRequests(activeCrafts).map((material) => ({
          name: material.name,
          perCraft: material.quantity,
          quantity: material.quantity,
          icon: material.icon
        }))
      };
    }

    function renderCraftSearchOptions() {
      if (!catalogLoaded) return;

      elements.craftOptions.innerHTML = craftCatalog.targets
        .map((target) => `<option value="${getTargetLabel(target)}"></option>`)
        .join("");
      elements.catalogMeta.textContent = t("craftsLoaded", { count: formatNumber(craftCatalog.targets.length) });
    }

    function syncSelectedCraftUi() {
      const selectedTarget = getCurrentTarget();
      const activeCrafts = getActiveCrafts();
      const primaryTarget = activeCrafts[0]?.target || selectedTarget;
      const hasActiveCrafts = activeCrafts.length > 0;
      const hasSingleActiveCraft = activeCrafts.length === 1;
      const titleItem = getCraftSetTitle(activeCrafts);
      const itemIcon = getIconUrl(primaryTarget ? primaryTarget.item.icon : "etc_recipe_black_i00");

      elements.title.textContent = hasSingleActiveCraft ? t("pageTitle", { item: titleItem }) : t("appTitle");
      elements.itemIcon.src = itemIcon;
      elements.itemIcon.alt = primaryTarget ? primaryTarget.item.name : "";
      elements.sourceLink.href = selectedTarget
        ? `https://l2hub.info/il/items/${selectedTarget.item.itemName}/craft`
        : "https://l2hub.info/il";
      elements.craftSearch.value = selectedTarget ? getTargetLabel(selectedTarget) : "";
      document.title = hasActiveCrafts ? t("pageTitle", { item: titleItem }) : t("appTitle");
    }

    function findCraftTargetFromSearch(value) {
      if (!catalogLoaded) return null;
      const cleanValue = value.trim().toLowerCase();
      if (!cleanValue) return null;

      return craftCatalog.targets.find((target) => (
        getTargetLabel(target).toLowerCase() === cleanValue ||
        target.recipeName?.toLowerCase() === cleanValue
      )) || craftCatalog.targets.find((target) => (
        getTargetLabel(target).toLowerCase().includes(cleanValue) ||
        target.item.itemName.toLowerCase().includes(cleanValue) ||
        target.recipeName?.toLowerCase().includes(cleanValue)
      )) || null;
    }

    function selectCraftTarget(target, { persist = true } = {}) {
      if (!target || readOnlyMode) return;
      const targetKey = getTargetKey(target);

      state.selectedTargetKey = targetKey;
      const existingCraft = state.crafts.find((craft) => craft.targetKey === targetKey);
      if (existingCraft) {
        state.quantity = existingCraft.quantity;
      } else {
        state.quantity = Math.max(toSafeNumber(state.quantity, defaultState.quantity), 1);
      }

      if (!state.crafts.length) {
        state.crafts = [{ targetKey, quantity: state.quantity }];
      }

      state.expanded[selectedCraftStateKey] = targetKey;
      syncCraftUrl();
      applyCatalogTarget();
      render({ persist });
      flushOnlineSave();
    }

    async function loadCraftCatalog() {
      try {
        catalogLoadFailed = false;
        let data = window.__L2CRAFT_INTERLUDE_CATALOG__;

        if (!data) {
          const response = await fetch("./data/interlude-crafts.json");
          if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
          data = await response.json();
        }

        craftCatalog = {
          targets: data.targets || [],
          items: data.items || []
        };
        catalogTargetsByKey = new Map(craftCatalog.targets.map((target) => [
          getTargetKey(target),
          target
        ]));
        catalogItemsById = new Map(craftCatalog.items.map((item) => [item.id, item]));
        catalogLoaded = craftCatalog.targets.length > 0;

        renderCraftSearchOptions();
        applyCatalogTarget();
        render({ online: false });
      } catch (error) {
        console.error(error);
        catalogLoadFailed = true;
        elements.catalogMeta.textContent = t("catalogLoadFailed");
        setEditingLocked(editingLocked);
      }
    }

    function showCatalogUnavailableToast() {
      showToast(catalogLoadFailed
        ? t("catalogUnavailable")
        : t("catalogStillLoading"));
    }

    function loadLocalState() {
      try {
        const stored = JSON.parse(localStorage.getItem(stateKey));
        return normalizeState(stored);
      } catch {
        return { ...defaultState };
      }
    }

    function renderSyncStatus() {
      if (!currentSyncStatus) return;

      elements.syncStatusBox.className = `sync-status ${currentSyncStatus.kind}`;
      elements.syncStatusText.textContent = currentSyncStatus.isKey
        ? t(currentSyncStatus.message, currentSyncStatus.params)
        : currentSyncStatus.message;
    }

    function setSyncStatus(kind, message, params = {}) {
      currentSyncStatus = {
        kind,
        message,
        params,
        isKey: isTranslationKey(message)
      };
      renderSyncStatus();
    }

    function applyReadOnlyModeChrome() {
      if (!readOnlyMode) return;

      elements.saveOnline.hidden = true;
      elements.copyProcessLink.hidden = true;
      elements.resetInventory.hidden = true;
      elements.fillRequired.hidden = true;
      elements.copyViewProcessLink.textContent = t("copyThisViewLink");
    }

    function setEditingLocked(locked) {
      editingLocked = locked || readOnlyMode;
      elements.craftSearch.disabled = editingLocked;
      elements.craftSearch.setAttribute("aria-busy", catalogLoaded ? "false" : "true");
      elements.craftQty.disabled = editingLocked;
      elements.addCraft.disabled = editingLocked;
      elements.saveOnline.disabled = editingLocked;
      elements.copyProcessLink.disabled = readOnlyMode;
      elements.resetInventory.disabled = editingLocked;
      elements.fillRequired.disabled = editingLocked;

      document.querySelectorAll("[data-preset], [data-material], [data-toggle-subitems], [data-craft-qty], [data-remove-craft]").forEach((control) => {
        control.disabled = editingLocked;
      });
    }

    function saveState({ online = true } = {}) {
      localStorage.setItem(stateKey, JSON.stringify(state));
      if (online) scheduleOnlineSave();
    }

    function getPublicState() {
      const expanded = {
        ...state.expanded,
        [selectedCraftStateKey]: getPrimaryCraftKey()
      };

      return {
        selectedTargetKey: state.selectedTargetKey,
        quantity: state.quantity,
        crafts: state.crafts,
        inventory: state.inventory,
        expanded,
        updatedAt: serverTimestamp()
      };
    }

    function startRealtimeSync(id, { waitForRemote = true } = {}) {
      if (!firebaseEnabled || !id) return false;
      if (realtimeProcessId === id && unsubscribeRealtime) return true;

      if (unsubscribeRealtime) {
        unsubscribeRealtime();
        unsubscribeRealtime = null;
      }

      realtimeProcessId = id;
      hasLoadedRemote = !waitForRemote;
      setEditingLocked(waitForRemote);
      setSyncStatus(
        waitForRemote ? "connecting" : "saving",
        waitForRemote
          ? (readOnlyMode ? "openingView" : "connectingProcess")
          : "savingOnline"
      );

      ensureFirestoreReady(id).catch((error) => {
        if (hasLoadedRemote) return;
        console.error(error);
        hasLoadedRemote = true;
        isLoadingRemote = false;
        setEditingLocked(false);
        setSyncStatus("error", error.message);
        showToast(error.message);
      });

      unsubscribeRealtime = onSnapshot(
        doc(db, "craftProcesses", id),
        (snapshot) => {
          hasLoadedRemote = true;
          setEditingLocked(false);

          if (!snapshot.exists()) {
            setSyncStatus("local", readOnlyMode ? "viewWithoutProcess" : "linkWithoutProcess");
            showToast(t("processNotSavedYet"));
            return;
          }

          isLoadingRemote = true;
          const activeMaterialInput = getActiveMaterialInput();
          const activeMaterialName = activeMaterialInput?.dataset.material;
          const activeMaterialValue = activeMaterialInput ? toSafeNumber(activeMaterialInput.value) : 0;
          state = normalizeState(snapshot.data());
          if (activeMaterialName && !readOnlyMode) {
            state.inventory[activeMaterialName] = activeMaterialValue;
          }
          localStorage.setItem(stateKey, JSON.stringify(state));
          if (activeMaterialName && !readOnlyMode) {
            refreshInventoryViews({ persist: false });
          } else {
            render({ persist: false });
          }
          isLoadingRemote = false;
          setSyncStatus(
            snapshot.metadata.hasPendingWrites ? "saving" : "online",
            snapshot.metadata.hasPendingWrites
              ? "savingOnline"
              : (readOnlyMode ? "realtimeView" : "realtimeOnline")
          );
        },
        (error) => {
          console.error(error);
          hasLoadedRemote = true;
          isLoadingRemote = false;
          setEditingLocked(false);
          const message = getFirebaseClientErrorMessage(error);
          setSyncStatus("error", message);
          showToast(message);
        }
      );

      return true;
    }

    async function saveOnline({ copyLink = false, copyReadOnlyLink = false, manual = false } = {}) {
      if (readOnlyMode) {
        showToast(t("readOnlyLink"));
        return;
      }

      if (!firebaseEnabled) {
        showToast(t("firebaseConfigMissing"));
        setSyncStatus("error", "firebaseNotConfigured");
        return;
      }

      if (processId && !hasLoadedRemote) {
        showToast(t("waitOnlineProcess"));
        return;
      }

      try {
        if (!processId) {
          processId = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
          const url = new URL(window.location.href);
          url.searchParams.set("id", processId);
          const craftKey = getPrimaryCraftKey({ activeOnly: true });
          if (craftKey) {
            url.searchParams.set("craft", craftKey);
          } else {
            url.searchParams.delete("craft");
          }
          window.history.replaceState({}, "", url);
          hasLoadedRemote = true;
        }

        window.clearTimeout(saveOnlineTimer);
        setSyncStatus("saving", "savingOnline");
        await ensureFirestoreReady(processId);
        await setDoc(doc(db, "craftProcesses", processId), getPublicState(), { merge: true });
        startRealtimeSync(processId, { waitForRemote: false });

        if (copyLink || copyReadOnlyLink) {
          await copyProcessLinkToClipboard(processId, { readOnly: copyReadOnlyLink });
        } else if (manual) {
          showToast(t("processSaved"));
        }
      } catch (error) {
        console.error(error);
        const message = getFirebaseClientErrorMessage(error);
        setSyncStatus("error", message);
        showToast(message);
      }
    }

    function scheduleOnlineSave() {
      if (readOnlyMode) return;
      if (!firebaseEnabled || !processId || isLoadingRemote || !hasLoadedRemote) return;
      window.clearTimeout(saveOnlineTimer);
      setSyncStatus("saving", "savingOnline");
      saveOnlineTimer = window.setTimeout(() => saveOnline(), 650);
    }

    function flushOnlineSave() {
      if (readOnlyMode) return;
      if (!firebaseEnabled || !processId || isLoadingRemote || !hasLoadedRemote) return;
      window.clearTimeout(saveOnlineTimer);
      saveOnline();
    }

    function toSafeNumber(value, fallback = 0) {
      const number = Number(value);
      if (!Number.isFinite(number) || number < 0) return fallback;
      return Math.floor(number);
    }

    function formatNumber(value) {
      return formatter.format(value);
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (character) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "\"": "&quot;",
        "'": "&#39;"
      }[character]));
    }

    function getItemIcon(name) {
      return itemIcons[name] || "https://l2hub.info/s/icons-gf/etc_recipe_black_i00.png";
    }

    function getTotal(material) {
      return toSafeNumber(material.quantity ?? material.perCraft);
    }

    function getHave(material) {
      return toSafeNumber(state.inventory[material.name]);
    }

    function getMissing(material) {
      return Math.max(getTotal(material) - getHave(material), 0);
    }

    function isExpanded(name) {
      return Boolean(state.expanded[name]);
    }

    function getDisplayRows(inventory = state.inventory) {
      const available = Object.fromEntries(
        Object.entries(inventory).map(([name, value]) => [name, toSafeNumber(value)])
      );
      const rows = [];

      // Percorre a arvore inteira consumindo o inventario na MESMA ordem do
      // calculo global (calculateExpandedPlan), mas guarda os valores POR RAMO
      // em vez de somar por nome. Assim "Iron Ore" sob Mithril Alloy mostra so
      // o necessario para aquele ramo, e a soma dos ramos = o total global.
      // So emite linha para nos visiveis (todos os ancestrais expandidos).
      function visit(name, quantity, depth, path, visible) {
        const availableQty = toSafeNumber(available[name]);
        const used = Math.min(availableQty, quantity);
        available[name] = availableQty - used;
        const missing = quantity - used;

        const craft = craftRecipes[name];
        const craftQty = craft && missing > 0 ? Math.ceil(missing / craft.resultQty) : 0;
        const id = path ? `${path}>${name}` : name;

        if (visible && quantity > 0) {
          rows.push({
            id,
            name,
            depth,
            required: quantity,
            missing,
            craftQty,
            craftable: Boolean(craft)
          });
        }

        if (!craft || craftQty <= 0) return;

        const childVisible = visible && isExpanded(name);
        sortMaterialsByPriority(craft.materials).forEach((material) => {
          visit(material.name, material.qty * craftQty, depth + 1, id, childVisible);
        });
      }

      recipe.materials.forEach((material) => {
        visit(material.name, getTotal(material), 0, "", true);
      });

      return rows;
    }

    function calculateExpandedPlan(inventory = state.inventory) {
      const available = Object.fromEntries(
        Object.entries(inventory).map(([name, value]) => [name, toSafeNumber(value)])
      );
      const rows = new Map();
      const leafRows = new Map();
      let subcraftCount = 0;

      function ensureRow(name, depth) {
        if (!rows.has(name)) {
          rows.set(name, {
            name,
            required: 0,
            used: 0,
            missing: 0,
            craftQty: 0,
            depth,
            craftable: Boolean(craftRecipes[name])
          });
        }

        const row = rows.get(name);
        row.depth = Math.min(row.depth, depth);
        return row;
      }

      function addLeafNeed(name, quantity, depth) {
        if (!leafRows.has(name)) {
          leafRows.set(name, {
            name,
            missing: 0,
            depth
          });
        }

        const row = leafRows.get(name);
        row.missing += quantity;
        row.depth = Math.min(row.depth, depth);
      }

      function requestItem(name, quantity, depth) {
        const row = ensureRow(name, depth);
        row.required += quantity;

        const availableQty = toSafeNumber(available[name]);
        const used = Math.min(availableQty, quantity);
        available[name] = availableQty - used;
        row.used += used;

        const missing = quantity - used;
        row.missing += missing;
        if (missing <= 0) return;

        const craft = craftRecipes[name];
        if (!craft) {
          addLeafNeed(name, missing, depth);
          return;
        }

        const craftQty = Math.ceil(missing / craft.resultQty);
        row.craftQty += craftQty;
        subcraftCount += craftQty;

        sortMaterialsByPriority(craft.materials).forEach((material) => {
          requestItem(material.name, material.qty * craftQty, depth + 1);
        });
      }

      recipe.materials.forEach((material) => {
        requestItem(material.name, getTotal(material), 0);
      });

      return {
        rows: [...rows.values()],
        leafRows: sortMaterialsByPriority([...leafRows.values()]),
        subcraftCount
      };
    }

    function getHierarchicalMaterialsPercent(inventory = state.inventory) {
      const available = Object.fromEntries(
        Object.entries(inventory).map(([name, value]) => [name, toSafeNumber(value)])
      );
      const topMaterials = recipe.materials
        .map((material) => ({
          name: material.name,
          quantity: getTotal(material)
        }))
        .filter((material) => material.quantity > 0);

      if (!topMaterials.length) return 0;

      const topWeight = 1 / topMaterials.length;
      const completedWeight = topMaterials.reduce(
        (sum, material) => sum + getRequirementProgressWeight(material.name, material.quantity, topWeight, available),
        0
      );

      return Math.min(Math.round(completedWeight * 100), 100);
    }

    function getRequirementProgressWeight(name, quantity, weight, available, trail = new Set()) {
      const required = toSafeNumber(quantity);
      if (required <= 0 || weight <= 0) return 0;

      const availableQty = toSafeNumber(available[name]);
      const used = Math.min(availableQty, required);
      available[name] = availableQty - used;

      const missing = required - used;
      let completedWeight = weight * (used / required);
      if (missing <= 0) return completedWeight;

      const craft = craftRecipes[name];
      if (!craft || trail.has(name)) return completedWeight;

      const resultQty = Math.max(toSafeNumber(craft.resultQty, 1), 1);
      const craftQty = Math.ceil(missing / resultQty);
      const subMaterials = craft.materials
        .map((material) => ({
          name: material.name,
          quantity: material.qty * craftQty
        }))
        .filter((material) => material.quantity > 0);

      if (!subMaterials.length) return completedWeight;

      const nextTrail = new Set(trail);
      nextTrail.add(name);
      const missingWeight = weight * (missing / required);
      const subWeight = missingWeight / subMaterials.length;

      completedWeight += subMaterials.reduce(
        (sum, material) => sum + getRequirementProgressWeight(material.name, material.quantity, subWeight, available, nextTrail),
        0
      );

      return completedWeight;
    }

    function getOverallProgress() {
      const baseline = calculateExpandedPlan({});
      const current = calculateExpandedPlan();
      const required = baseline.leafRows.reduce((sum, row) => sum + row.missing, 0);
      const missing = current.leafRows.reduce((sum, row) => sum + row.missing, 0);
      const have = Math.max(required - missing, 0);

      return {
        have,
        required,
        percent: getHierarchicalMaterialsPercent()
      };
    }

    function maybeCelebrateOverallCompletion(percent) {
      const completedNow = percent >= 100;
      const wasIncomplete = previousOverallProgressPercent !== null && previousOverallProgressPercent < 100;
      previousOverallProgressPercent = percent;

      if (completedNow && wasIncomplete) {
        launchFireworks();
      }
    }

    function launchFireworks() {
      const canvas = elements.fireworksCanvas;
      if (!canvas || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

      const context = canvas.getContext("2d");
      if (!context) return;

      const colors = ["#fac459", "#ffce6d", "#ea6944", "#21af69", "#5db7ff", "#f7f0df"];
      const resizeCanvas = () => {
        const dpr = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = Math.round(window.innerWidth * dpr);
        canvas.height = Math.round(window.innerHeight * dpr);
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
      };
      const burst = (x, y, count) => {
        for (let index = 0; index < count; index += 1) {
          const angle = (Math.PI * 2 * index) / count + Math.random() * 0.28;
          const speed = 1.7 + Math.random() * 4.2;
          fireworksParticles.push({
            x,
            y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            radius: 1.4 + Math.random() * 2.2,
            alpha: 1,
            decay: 0.011 + Math.random() * 0.012,
            gravity: 0.035 + Math.random() * 0.025,
            color: colors[Math.floor(Math.random() * colors.length)]
          });
        }
      };
      const animate = () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.globalCompositeOperation = "lighter";

        fireworksParticles = fireworksParticles.filter((particle) => particle.alpha > 0.02);
        fireworksParticles.forEach((particle) => {
          particle.x += particle.vx;
          particle.y += particle.vy;
          particle.vy += particle.gravity;
          particle.vx *= 0.992;
          particle.vy *= 0.992;
          particle.alpha -= particle.decay;

          context.globalAlpha = Math.max(particle.alpha, 0);
          context.beginPath();
          context.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
          context.fillStyle = particle.color;
          context.fill();
        });

        context.globalAlpha = 1;
        context.globalCompositeOperation = "source-over";

        if (fireworksParticles.length) {
          fireworksAnimationFrame = window.requestAnimationFrame(animate);
        } else {
          canvas.classList.remove("active");
          fireworksAnimationFrame = 0;
        }
      };

      window.cancelAnimationFrame(fireworksAnimationFrame);
      window.clearTimeout(fireworksStopTimer);
      resizeCanvas();
      fireworksParticles = [];
      canvas.classList.add("active");

      [0.18, 0.34, 0.5, 0.66, 0.82].forEach((position, index) => {
        window.setTimeout(() => {
          burst(
            window.innerWidth * position,
            window.innerHeight * (0.18 + Math.random() * 0.28),
            34 + index * 4
          );
          if (!fireworksAnimationFrame) {
            fireworksAnimationFrame = window.requestAnimationFrame(animate);
          }
        }, index * 190);
      });

      fireworksStopTimer = window.setTimeout(() => {
        fireworksParticles = [];
      }, 3200);
    }

    function renderOverallProgress() {
      const progress = getOverallProgress();
      elements.overallProgressBar.style.width = `${progress.percent}%`;
      elements.overallProgressText.textContent = `${progress.percent}%`;
      elements.overallProgressCard.textContent = `${progress.percent}%`;
      elements.overallProgressUnits.textContent = `${formatNumber(progress.have)} / ${formatNumber(progress.required)} ${t("materialsUnit")}`;
      maybeCelebrateOverallCompletion(progress.percent);
    }

    function renderCraftSummaryStats() {
      const activeCrafts = getActiveCrafts();
      elements.successRate.textContent = getSuccessRateSummary(activeCrafts);
      elements.expectedSuccess.textContent = decimalFormatter.format(getExpectedSuccessTotal(activeCrafts));
    }

    function renderActiveCrafts() {
      const activeCrafts = getActiveCrafts();
      elements.activeCraftCount.textContent = formatNumber(activeCrafts.length);

      if (!activeCrafts.length) {
        elements.activeCrafts.innerHTML = `<div class="craft-cart-empty">${t("noActiveCrafts")}</div>`;
        return;
      }

      elements.activeCrafts.innerHTML = activeCrafts.map((craft) => {
        const itemName = escapeHtml(craft.item);
        const targetKey = escapeHtml(craft.targetKey);
        const iconUrl = escapeHtml(getIconUrl(craft.target.item.icon));
        const successRateLabel = escapeHtml(craft.successRateLabel);
        const changeQtyLabel = escapeHtml(t("changeCraftQty", { item: craft.item }));
        const removeCraftLabel = escapeHtml(t("removeCraft", { item: craft.item }));

        return `
          <div class="craft-cart-row" data-craft-row="${targetKey}">
            <span class="item-ref">
              <img src="${iconUrl}" alt="" />
              <span>
                ${itemName}
                <span class="exchange-rate">${successRateLabel}</span>
              </span>
            </span>
            <input
              type="number"
              min="1"
              step="1"
              inputmode="numeric"
              value="${craft.quantity}"
              aria-label="${changeQtyLabel}"
              data-craft-qty="${targetKey}"
              ${editingLocked ? "disabled" : ""}
            />
            <button
              class="craft-remove"
              type="button"
              aria-label="${removeCraftLabel}"
              title="${removeCraftLabel}"
              data-remove-craft="${targetKey}"
              ${editingLocked ? "disabled" : ""}
            >x</button>
          </div>
        `;
      }).join("");
    }

    function setSelectedQuantity(quantity) {
      state.quantity = Math.max(toSafeNumber(quantity, 1), 1);
      const selectedCraft = state.crafts.find((craft) => craft.targetKey === state.selectedTargetKey);
      if (selectedCraft) {
        selectedCraft.quantity = state.quantity;
      }
    }

    function upsertSelectedCraft() {
      if (readOnlyMode || editingLocked) return;

      const target = getCurrentTarget();
      if (!target) {
        showToast(t("itemNotFound"));
        return;
      }

      const targetKey = getTargetKey(target);
      const quantity = Math.max(toSafeNumber(elements.craftQty.value, state.quantity), 1);
      const existingCraft = state.crafts.find((craft) => craft.targetKey === targetKey);

      state.selectedTargetKey = targetKey;
      state.quantity = quantity;
      if (existingCraft) {
        existingCraft.quantity = quantity;
      } else {
        state.crafts.push({ targetKey, quantity });
      }

      state.expanded[selectedCraftStateKey] = targetKey;
      syncCraftUrl();
      render();
      flushOnlineSave();
      showToast(t(existingCraft ? "craftUpdated" : "craftAdded", { item: target.item.name }));
    }

    function setActiveCraftQuantity(targetKey, quantity) {
      const craft = state.crafts.find((entry) => entry.targetKey === targetKey);
      if (!craft) return false;

      craft.quantity = Math.max(toSafeNumber(quantity, 1), 1);
      state.selectedTargetKey = targetKey;
      state.quantity = craft.quantity;
      state.expanded[selectedCraftStateKey] = targetKey;
      return true;
    }

    function removeActiveCraft(targetKey) {
      if (readOnlyMode || editingLocked) return;

      const target = catalogTargetsByKey.get(targetKey);
      state.crafts = state.crafts.filter((craft) => craft.targetKey !== targetKey);
      if (state.selectedTargetKey === targetKey) {
        state.selectedTargetKey = state.crafts[0]?.targetKey || targetKey;
        const nextCraft = state.crafts.find((craft) => craft.targetKey === state.selectedTargetKey);
        if (nextCraft) state.quantity = nextCraft.quantity;
      }

      syncCraftUrl();
      render();
      flushOnlineSave();
      if (target) showToast(t("craftRemoved", { item: target.item.name }));
    }

    function render({ persist = true, online = true } = {}) {
      applyCatalogTarget();
      state.quantity = Math.max(toSafeNumber(state.quantity, 20), 1);
      syncSelectedCraftUi();
      renderActiveCrafts();
      elements.craftQty.value = state.quantity;
      elements.craftQty.disabled = editingLocked;
      renderCraftSummaryStats();

      document.querySelectorAll("[data-preset]").forEach((button) => {
        button.classList.toggle("active", Number(button.dataset.preset) === state.quantity);
        button.disabled = editingLocked;
      });

      renderMaterials();
      renderOverallProgress();
      renderMissing();
      setEditingLocked(editingLocked);
      if (persist) saveState({ online });
    }

    function refreshCraftCalculationViews({ persist = true, online = true } = {}) {
      applyCatalogTarget();
      syncSelectedCraftUi();
      elements.craftQty.value = state.quantity;
      renderCraftSummaryStats();
      renderMaterials();
      renderOverallProgress();
      renderMissing();
      setEditingLocked(editingLocked);
      if (persist) saveState({ online });
    }

    function renderMaterials() {
      if (!recipe.materials.length) {
        elements.materials.innerHTML = `<div class="empty-materials">${t("selectCraftFirst")}</div>`;
        return;
      }

      const header = `
        <div class="plan-row header">
          <span>${t("material")}</span>
          <span>${t("have")}</span>
          <span>${t("progressPercent")}</span>
        </div>
      `;

      const rows = getDisplayRows()
        .filter((row) => row.required > 0)
        .map((row) => {
          const have = getHave({ name: row.name });
          const missing = Math.max(row.missing, 0);
          const missingPercent = row.required === 0 ? 0 : Math.min(Math.round((missing / row.required) * 100), 100);
          const havePercent = Math.max(100 - missingPercent, 0);
          const canExpand = row.craftQty > 0;
          const expanded = isExpanded(row.name);
          const toggleAction = expanded ? t("collapseSubitems") : t("expandSubitems");

          return `
          <div class="plan-row ${row.depth > 0 ? "subitem-row" : ""}" data-plan-row="${row.id}">
            <div
              class="cell plan-name ${canExpand ? "has-subitems" : ""}"
              data-label="${t("material")}"
              style="--depth: ${row.depth}"
              ${canExpand ? `
                data-toggle-subitems="${row.name}"
                role="button"
                tabindex="${editingLocked ? "-1" : "0"}"
                aria-expanded="${expanded ? "true" : "false"}"
                aria-label="${t("expandSubitemsOf", { action: toggleAction, item: row.name, qty: formatNumber(row.craftQty) })}"
                title="${t("subitemsTitle", { action: toggleAction })}"
              ` : ""}
            >
              <span class="item-ref">
                <img src="${getItemIcon(row.name)}" alt="" />
                <span>${row.name} <span class="item-qty">x${formatNumber(row.required)}</span></span>
              </span>
            </div>
            <div class="cell" data-label="${t("have")}">
              <input
                type="number"
                min="0"
                step="1"
                inputmode="numeric"
                value="${have}"
                aria-label="${t("haveItem", { item: row.name })}"
                data-material="${row.name}"
                ${editingLocked ? "disabled" : ""}
              />
            </div>
            <div class="cell progress-percent ${missing === 0 ? "ready" : "missing"}" data-label="${t("progressPercent")}" data-progress-cell>
              <span data-progress-value>${havePercent}%</span>
              <div class="progress" aria-label="${t("progressOf", { item: row.name })}">
                <div class="progress-fill" data-progress-fill style="width: ${havePercent}%"></div>
              </div>
            </div>
          </div>
        `;
        }).join("");

      elements.materials.innerHTML = header + rows;
    }

    function getFangExchangeNeeds(inventory = state.inventory) {
      const available = Object.fromEntries(
        Object.entries(inventory).map(([name, value]) => [name, toSafeNumber(value)])
      );
      const needsByName = new Map();

      function addNeed(name, quantity) {
        needsByName.set(name, (needsByName.get(name) || 0) + quantity);
      }

      function requestBuyableMaterial(name, quantity, trail = new Set()) {
        const required = toSafeNumber(quantity);
        if (required <= 0) return;

        const availableQty = toSafeNumber(available[name]);
        const used = Math.min(availableQty, required);
        available[name] = availableQty - used;

        const missing = required - used;
        if (missing <= 0) return;

        if (fangExchangeByName.has(name)) {
          addNeed(name, missing);
          return;
        }

        const craft = craftRecipes[name];
        if (!craft || trail.has(name)) return;

        const resultQty = Math.max(toSafeNumber(craft.resultQty, 1), 1);
        const craftQty = Math.ceil(missing / resultQty);
        const nextTrail = new Set(trail);
        nextTrail.add(name);

        craft.materials.forEach((material) => {
          requestBuyableMaterial(material.name, material.qty * craftQty, nextTrail);
        });
      }

      recipe.materials.forEach((material) => {
        requestBuyableMaterial(material.name, getTotal(material));
      });

      return fangExchangeRates
        .map((rate) => {
          const missing = needsByName.get(rate.name) || 0;
          const packs = Math.ceil(missing / rate.quantity);
          return {
            ...rate,
            missing,
            packs,
            received: packs * rate.quantity,
            totalFang: packs * rate.fangCost
          };
        })
        .filter((entry) => entry.missing > 0);
    }

    function renderFangCalculator() {
      if (!recipe.materials.length) {
        elements.fangTotal.textContent = `0 ${t("fang")}`;
        elements.fangList.innerHTML = `<li><span>${t("selectCraftFirst")}</span><strong>-</strong></li>`;
        return;
      }

      const entries = getFangExchangeNeeds();
      const totalFang = entries.reduce((sum, entry) => sum + entry.totalFang, 0);

      elements.fangTotal.textContent = `${formatNumber(totalFang)} ${t("fang")}`;
      elements.fangList.innerHTML = entries.length
        ? entries.map((entry) => `
          <li>
            <span class="item-ref">
              <img src="${getItemIcon(entry.name)}" alt="" />
              <span>
                ${entry.name}
                <span class="exchange-rate">x${formatNumber(entry.quantity)} = ${formatNumber(entry.fangCost)} ${t("fang")}</span>
              </span>
            </span>
            <strong class="exchange-cost">
              ${formatNumber(entry.totalFang)} ${t("fang")}
              <small>${formatNumber(entry.missing)} / ${formatNumber(entry.received)}</small>
            </strong>
          </li>
        `).join("")
        : `<li><span>${t("noBuyableMissing")}</span><strong>0 ${t("fang")}</strong></li>`;
    }

    function getPendingCrafts(plan = calculateExpandedPlan()) {
      return sortMaterialsByPriority(plan.rows)
        .filter((row) => row.craftable && row.craftQty > 0);
    }

    function renderPendingCrafts(plan = calculateExpandedPlan()) {
      if (!recipe.materials.length) {
        elements.pendingCraftTotal.textContent = "0";
        elements.pendingCraftList.innerHTML = `<li><span>${t("selectCraftFirst")}</span><strong>-</strong></li>`;
        return;
      }

      const pendingCrafts = getPendingCrafts(plan);
      const totalCrafts = pendingCrafts.reduce((sum, craft) => sum + craft.craftQty, 0);
      elements.pendingCraftTotal.textContent = formatNumber(totalCrafts);

      elements.pendingCraftList.innerHTML = pendingCrafts.length
        ? pendingCrafts.map((craft) => `
          <li>
            <span class="item-ref">
              <img src="${getItemIcon(craft.name)}" alt="" />
              <span>${craft.name}</span>
            </span>
            <strong>x${formatNumber(craft.craftQty)}</strong>
          </li>
        `).join("")
        : `<li><span>${t("noPendingCrafts")}</span><strong>OK</strong></li>`;
    }

    function renderMissing() {
      if (!recipe.materials.length) {
        elements.missingKinds.textContent = "0";
        elements.missingTotal.textContent = "0";
        elements.missingList.innerHTML = `<li><span>${t("selectCraftFirst")}</span><strong>-</strong></li>`;
        renderPendingCrafts();
        renderFangCalculator();
        return;
      }

      const plan = calculateExpandedPlan();
      const missingItems = plan.leafRows
        .filter((material) => material.missing > 0);

      elements.missingKinds.textContent = missingItems.length;
      elements.missingTotal.textContent = formatNumber(
        missingItems.reduce((sum, material) => sum + material.missing, 0)
      );

      elements.missingList.innerHTML = missingItems.length
        ? missingItems.map((material) => `
          <li>
            <span class="item-ref">
              <img src="${getItemIcon(material.name)}" alt="" />
              <span>${material.name}</span>
            </span>
            <strong>x${formatNumber(material.missing)}</strong>
          </li>
        `).join("")
        : `<li><span>${t("allReady")}</span><strong>OK</strong></li>`;

      renderPendingCrafts(plan);
      renderFangCalculator();
    }

    function showToast(message) {
      elements.toast.textContent = message;
      window.clearTimeout(showToast.timeout);
      showToast.timeout = window.setTimeout(() => {
        elements.toast.textContent = "";
      }, 2200);
    }

    function getMissingText() {
      const plan = calculateExpandedPlan();
      const lines = plan.leafRows
        .filter((material) => material.missing > 0)
        .map((material) => `${material.name}: ${formatNumber(material.missing)}`);
      const pendingCrafts = getPendingCrafts(plan);
      const pendingCraftLines = pendingCrafts.map((craft) => t("pendingCraftTextLine", {
        item: craft.name,
        crafts: formatNumber(craft.craftQty)
      }));

      if (!recipe.materials.length) return t("selectCraftFirst");
      if (!lines.length && !pendingCraftLines.length) return t("missingTextReady", { item: recipe.item });

      const fangEntries = getFangExchangeNeeds();
      if (fangEntries.length) {
        const totalFang = fangEntries.reduce((sum, entry) => sum + entry.totalFang, 0);
        lines.push(
          "",
          t("missingFangAlternativeHeader"),
          ...fangEntries.map((entry) => t("missingFangAlternativeLine", {
            item: entry.name,
            missing: formatNumber(entry.missing),
            fang: formatNumber(entry.totalFang)
          })),
          t("missingFangAlternativeTotal", { fang: formatNumber(totalFang) })
        );
      }

      if (pendingCraftLines.length) {
        lines.push("", t("pendingCraftTextHeader"), ...pendingCraftLines);
      }

      return [t("missingTextHeader", { item: recipe.item, qty: getTotalCraftQuantity() }), ...lines].join("\n");
    }

    function getActiveMaterialInput() {
      const activeElement = document.activeElement;
      if (!activeElement?.matches?.("[data-material]")) return null;
      return activeElement;
    }

    function refreshVisibleMaterialRows() {
      const rowById = new Map(getDisplayRows().map((row) => [row.id, row]));

      elements.materials.querySelectorAll("[data-plan-row]").forEach((rowElement) => {
        const row = rowById.get(rowElement.dataset.planRow);
        if (!row) return;

        const missing = Math.max(row.missing, 0);
        const missingPercent = row.required === 0 ? 0 : Math.min(Math.round((missing / row.required) * 100), 100);
        const havePercent = Math.max(100 - missingPercent, 0);
        const progressCell = rowElement.querySelector("[data-progress-cell]");
        const progressValue = rowElement.querySelector("[data-progress-value]");
        const progressFill = rowElement.querySelector("[data-progress-fill]");

        if (progressCell) {
          progressCell.classList.toggle("ready", missing === 0);
          progressCell.classList.toggle("missing", missing !== 0);
        }
        if (progressValue) progressValue.textContent = `${havePercent}%`;
        if (progressFill) progressFill.style.width = `${havePercent}%`;
      });
    }

    function refreshInventoryViews({ persist = true, online = false } = {}) {
      refreshVisibleMaterialRows();
      renderOverallProgress();
      renderMissing();
      if (persist) saveState({ online });
    }

    elements.craftSearch.addEventListener("change", (event) => {
      if (!catalogLoaded) {
        syncSelectedCraftUi();
        showCatalogUnavailableToast();
        return;
      }

      const target = findCraftTargetFromSearch(event.target.value);
      if (!target) {
        syncSelectedCraftUi();
        showToast(t("itemNotFound"));
        return;
      }

      selectCraftTarget(target);
    });

    elements.craftSearch.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();

      if (!catalogLoaded) {
        showCatalogUnavailableToast();
        return;
      }

      const target = findCraftTargetFromSearch(event.currentTarget.value);

      if (!target) {
        showToast(t("itemNotFound"));
        return;
      }

      selectCraftTarget(target);
    });

    elements.craftQty.addEventListener("input", (event) => {
      if (readOnlyMode) return;
      setSelectedQuantity(event.target.value);
      render();
    });

    elements.craftQty.addEventListener("change", (event) => {
      if (readOnlyMode) return;
      setSelectedQuantity(event.target.value);
      render();
      flushOnlineSave();
    });

    elements.addCraft.addEventListener("click", () => {
      upsertSelectedCraft();
    });

    elements.activeCrafts.addEventListener("input", (event) => {
      if (readOnlyMode || editingLocked) return;
      if (!event.target.matches("[data-craft-qty]")) return;
      if (!setActiveCraftQuantity(event.target.dataset.craftQty, event.target.value)) return;
      refreshCraftCalculationViews({ online: true });
    });

    elements.activeCrafts.addEventListener("change", (event) => {
      if (readOnlyMode || editingLocked) return;
      if (!event.target.matches("[data-craft-qty]")) return;
      if (!setActiveCraftQuantity(event.target.dataset.craftQty, event.target.value)) return;
      render();
      flushOnlineSave();
    });

    elements.activeCrafts.addEventListener("click", (event) => {
      if (readOnlyMode || editingLocked) return;
      const removeButton = event.target.closest("[data-remove-craft]");
      if (!removeButton) return;
      removeActiveCraft(removeButton.dataset.removeCraft);
    });

    elements.materials.addEventListener("input", (event) => {
      if (readOnlyMode || editingLocked) return;
      if (!event.target.matches("[data-material]")) return;
      const materialName = event.target.dataset.material;
      state.inventory[materialName] = toSafeNumber(event.target.value);
      refreshInventoryViews({ online: true });
    });

    elements.materials.addEventListener("change", (event) => {
      if (readOnlyMode || editingLocked) return;
      if (!event.target.matches("[data-material]")) return;
      const materialName = event.target.dataset.material;
      state.inventory[materialName] = toSafeNumber(event.target.value);
      refreshInventoryViews({ online: true });
      flushOnlineSave();
    });

    elements.materials.addEventListener("focusout", () => {
      window.setTimeout(() => {
        if (getActiveMaterialInput()) return;
        render({ online: false });
      }, 0);
    });

    function toggleSubitems(materialName) {
      state.expanded[materialName] = !state.expanded[materialName];
      render();
    }

    elements.materials.addEventListener("click", (event) => {
      if (readOnlyMode || editingLocked) return;
      const toggle = event.target.closest("[data-toggle-subitems]");
      if (!toggle) return;

      toggleSubitems(toggle.dataset.toggleSubitems);
    });

    elements.materials.addEventListener("keydown", (event) => {
      if (readOnlyMode || editingLocked) return;
      if (event.key !== "Enter" && event.key !== " ") return;

      const toggle = event.target.closest("[data-toggle-subitems]");
      if (!toggle) return;

      event.preventDefault();
      toggleSubitems(toggle.dataset.toggleSubitems);
    });

    elements.languageButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setLanguage(button.dataset.language);
      });
    });

    document.querySelectorAll("[data-preset]").forEach((button) => {
      button.addEventListener("click", () => {
        if (readOnlyMode) return;
        setSelectedQuantity(button.dataset.preset);
        render();
        flushOnlineSave();
      });
    });

    document.querySelector("#resetInventory").addEventListener("click", () => {
      if (readOnlyMode) return;
      state.inventory = {};
      render();
      showToast(t("inventoryReset"));
    });

    document.querySelector("#fillRequired").addEventListener("click", () => {
      if (readOnlyMode) return;
      recipe.materials.forEach((material) => {
        state.inventory[material.name] = getTotal(material);
      });
      render();
      showToast(t("materialsMarkedReady"));
    });

    document.querySelector("#copyMissing").addEventListener("click", async () => {
      const text = getMissingText();
      try {
        await navigator.clipboard.writeText(text);
        showToast(t("missingCopied"));
      } catch {
        showToast(t("copyMissingManual"));
      }
    });

    document.querySelector("#saveOnline").addEventListener("click", () => {
      saveOnline({ manual: true });
    });

    elements.copyProcessLink.addEventListener("click", async () => {
      if (readOnlyMode) {
        showToast(t("readOnlyLink"));
        return;
      }

      if (!processId) {
        await saveOnline({ copyLink: true });
        return;
      }

      await copyProcessLinkToClipboard(processId);
    });

    elements.copyViewProcessLink.addEventListener("click", async () => {
      if (!processId) {
        await saveOnline({ copyReadOnlyLink: true });
        return;
      }

      await copyProcessLinkToClipboard(processId, { readOnly: true });
    });

    applyTranslations();
    applyReadOnlyModeChrome();
    loadCraftCatalog();

    if (processId) {
      startRealtimeSync(processId);
      render({ online: false });
    } else {
      setSyncStatus(firebaseEnabled ? "local" : "error", firebaseEnabled ? "localOnly" : "firebaseNotConfigured");
      render();
    }
